<template>
    <div>
        <modal name="dialog" :height="710" :width="1200">
            <div class="window-header">
                {{this.exhibitname}}
                ({{this.exhibitID}})
            </div>
            <div class="item-main">
                <div class="item-img"><img :src="img" alt=""></div>
                <div class="item-content">
                    <draggable class="item-main-eara" :list="maindetail" group="content" @change="log">
                        <div class="item-main-content" v-for="(maintext, index) in maindetail"  :key="index">            
                            <!-- <b-badge pill variant="info"><a href="#" @click="linkOpen('https://ja.wikipedia.org/wiki/' + maintext)">{{maintext}}</a></b-badge> -->
                            <b-badge pill variant="info"><a href="#">{{maintext}}</a></b-badge>
                        </div> 
                    </draggable>
                </div>
                <div class="item-other-contents">
                    <div class="contents">
                        <draggable class="list-inline" :list="otherdetail" group="content" @change="log">
                            <div class="list-inline-item" v-for="(othertext, index) in otherdetail" :key="index">
                                <b-badge pill variant="info"><a href="#">{{othertext}}</a></b-badge>
                            </div>
                        </draggable>
                    </div> 
                    <div class="addtag">
                        <b-form-input class="tag-input" v-model="tagdata" placeholder="新しいタグ" size="sm" @keydown.13="doInputText"></b-form-input>
                        <b-button class="tag-bnt" @click="addtag" size="sm">追加</b-button>
                    </div>
                </div>
            </div>

            <div class="memo">
                <div class="memo-head">
                    <b-badge pill variant="info">メモ</b-badge>
                    <div class="input">
                        <b-form-textarea 
                        class="memo-input" 
                        v-model="memo" 
                        placeholder="メモを入力してください"
                        rows="3"
                        max-rows="3"></b-form-textarea>
                    </div>
                </div>
            </div>

            <div class="item-text">
                <div class="use">
                    <span>用途・使用法</span>
                    <div>
                        <span>{{this.usefor}}</span>
                    </div>
                </div>
                <div class="material">
                    <span>製作法・材料</span>
                    <div>
                        <span>{{this.material}}</span>
                    </div>
                </div>
                <div class="distribution">
                    <span>遷移・分布</span>
                    <div>
                        <span>{{this.distribution}}</span>
                    </div>
                </div>
            </div>

            <div class="button">
                <b-button variant="outline-primary" class="change" @click="change">更新</b-button>
                <b-button variant="outline-primary" class="cancel" @click="cancel">取消</b-button>
            </div>     
        </modal>
    </div>
    
</template>

<script>
import draggable from 'vuedraggable'

export default {
    components: {
        draggable,
      },

    props: {
        exhibitdirt: {
            type: Object
        }
    },

    data() {
        return{
            checklist: [],
            checkmemo: [],
            tagdata:'',
            exhibitID: this.exhibitdirt.number,
            exhibitname: this.exhibitdirt.name,
            maindetail: this.exhibitdirt.main,
            otherdetail: this.exhibitdirt.other,
            memo: this.exhibitdirt.memo,
            img: this.exhibitdirt.url,
            usefor: this.exhibitdirt.usefor,
            material: this.exhibitdirt.material,
            distribution: this.exhibitdirt.distribution,
            // test:{
            //     "use": "用途・使用法",
            //     "use_text": "観光土産用のやきもの",
            //     "material": "製作法・材料",
            //     "material_text": "焼き物。材料：粘土。たたき技法による成形、石による磨研、いぶしによる黒色の器面、ネガティブ=ポジティブ技法による装飾が特徴。",
            //     "distribution": "遷移・分布",
            //     "distribution_text": "1970年代にヘラシモ・ソサを中心として、従来のチチャ醸造用の壺、甕製作の技法、特にたたき技法を取り入れながら、先スペイン期のビクス文化のネガティブ文様、石による磨研などの技法を現代に復活したいという若者たちによって創造された焼き物。はじめはピウラ市などペルー北海岸に限られていたが、1980年代になって首都のリマ市でも置かれるようになり、1997年には南高地のクスコ市にも専門の商店が現れた。"
            
            // }
        }
    }, 

    methods: {
        //関連語のWikipediaページを開く
        linkOpen (url) {
            window.open(url,'_b.lank')
        },
        //関連語を移動する用
        log: function(evt) {
            window.console.log("this is change")
            window.console.log(evt);
        },

        //メモを追加した場合、「空白とかスペース」などを排除する
        addtag: function(){
            var ret = this.tagdata
            ret = ret.replace( /^[\s]*/, "" );
            ret = ret.replace( /[\s]*$/, "" );
            if (ret.length > 0 && this.otherdetail.indexOf(ret) < 0 && this.maindetail.indexOf(ret) < 0) {
                this.checkmemo.push(ret);
                this.otherdetail.push(ret);
                window.console.log(10)
            }else{
                alert("空白なタグや重複なタグが追加できません。タグを確認をお願いします。")
            }
            this.tagdata = ''
        },

        //取消ボタンを押した場合
        cancel: function(){
            this.checkmemo = []
            this.$modal.hide('dialog')
        },
        
        //更新ボタンを押した場合
        change: function(){
            window.console.log("I want to change item")
            this.$emit("changedirt")
            this.checkmemo = []
            this.$modal.hide('dialog')
        },

        doInputText: function(){
            var ret = this.tagdata
            ret = ret.replace( /^[\s]*/, "" );
            ret = ret.replace( /[\s]*$/, "" );
            if (ret.length > 0){
                this.checkmemo.push(ret);
                this.otherdetail.push(ret);
                window.console.log(10)
            }
            this.tagdata = ''
        }
    },
    //データ変更したかを確認⇒展示物への詳細情報が三つ以上になった、かつ移動する語はメモーにない場合、その他の関連語に追加
    watch: {
        exhibit: function(){
            window.console.log(this.exhibit)
        },
        exhibitdirt: function(){
            window.console.log(this.exhibitdirt.memo)
            this.exhibitID = this.exhibitdirt.number,
            this.exhibitname = this.exhibitdirt.name
            this.maindetail = this.exhibitdirt.main
            this.otherdetail = this.exhibitdirt.other
            this.memo = this.exhibitdirt.memo
            this.img = this.exhibitdirt.url
            this.usefor = this.exhibitdirt.usefor
            this.material = this.exhibitdirt.material
            this.distribution = this.exhibitdirt.distribution
        },
        maindetail: function() {
            window.console.log(this.maindetail)
            if (this.maindetail.length > 4 && this.memo.indexOf(this.maindetail[4]) == -1){
                this.otherdetail.unshift(this.maindetail[4]);
                this.maindetail.pop();
            }
        },
        memo: function(){
            window.console.log("addmemolist")
            window.console.log(this.memo)
            window.console.log("memolist")
            window.console.log(this.exhibitdirt.memo)
            window.console.log("mainlist")
            window.console.log(this.exhibitdirt.main)
            window.console.log("otherlist")
            window.console.log(this.exhibitdirt.other)
            // window.consloe.log(this.exhibitdirt.other)
            // if (this.memo.indexOf(this.exhibitdirt.main) == -1 && this.memo.indexOf(this.exhibitdirt.other) == -1){
            //     if (this.memo.toString() != this.checkmemo.toString() && this.memo.indexOf(this.checkmemo) == -1) {
            //         this.memo = this.checkmemo.slice(0);
            //     }
            // }
        }
    }
}
</script>

<style type="css" scoped>
.dialog{
    background-image: url(../../assets/img/dialog.jpg)
}

.window-header{
    margin: auto;
    margin-left: 15px;
    font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic,
        "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
    color: #333333;
    font-size: 20px;
    font-weight: bold;
}

.item-main{
    width:1180px;
    height: 170px;
    margin: auto;
    margin-top: px;
    margin-left: 5px;
    display: flex;
}
.item-main .item-img{
    width: 170px;
    height:160px;
    margin: auto;
    /* float: left; */
}
.item-main .item-img img{
    width: 100%;
    height: 100%;
}
.item-main .item-content{
    width: 300px;
    height:160px;
    max-width: 300px;
    max-height: 160px;
    border-radius: 10px;
    border: rgb(251, 253, 225) solid 2px;
    background: rgb(251, 253, 225);
    text-align: center;
    margin: auto;
    display: flex;
    flex-direction: column;
}
.item-main .item-content .item-main-eara{
    border-radius: 10px;
    margin: auto;
    display: flex;
    flex-direction: column;
}
.item-main .item-content .item-main-content{
    margin: 2px;
    overflow:hidden;
}
.item-main .item-content a{
    margin: auto;
    word-break: keep-all;
    text-align: center;
    font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic,
        "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
    color: #333333;
    font-size: 20px;
    font-weight: bold;
    display: block;
    /* border-radius: 10px;
    border: rgb(110, 183, 231) solid 2px;
    background: rgb(110, 183, 231); */
    
}

.item-other-contents{
    width: 600px;
    height: 160px;
    max-width: 600px;
    margin: auto;
    border-radius: 10px;
    border: rgb(251, 253, 225) solid 2px;
    background: rgb(251, 253, 225);
}

.item-other-contents .contents{
    width: 600px;
    height: 120px;
    margin: 2px;
    /* font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic,
        "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
    color: #333333;
    font-size: 20px;
    font-weight: bold; */
    display: flex;
    flex-wrap: wrap
}

.item-other-contents .contents a{
    margin: auto;
    word-break: keep-all;
    text-align: center;
    font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic,
        "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
    color: #333333;
    font-size: 18px;
    font-weight: bold;
} 

.item-other-contents .addtag{
    width: 300px;
    height: 20px;
    float: right;
}


.item-other-contents .addtag .tag-input{
    width: 250px;
    text-align: left;
    float:left;
}

.item-other-contents .addtag .tag-bnt{
    float: right;
}

.memo{
    width: 1180px;
    height: 130px;
    margin: auto;
    margin-top: 10px;
    border-radius: 10px;
    border: rgb(221, 226, 209) solid 2px;
    background: rgb(221, 226, 209)
}

.memo .memo-head{
    width: 1180px;
    height: 20px;
}

.memo .memo-head span{
    margin: 2px;
    border-radius: 5px;
    border: rgb(118, 217, 241) solid 2px;
    background: rgb(118, 217, 241);
    font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic,
        "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
    color: #333333;
    font-size: 15px;
    font-weight: bold;
    float: left;
} 

.memo .memo-content{
    width: 1180px;
    height: 80px;
    overflow: auto;
}

/* .memo a{
    margin: 3px;
    word-break: keep-all;
    text-align: center;
    font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic,
        "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
    color: #333333;
    font-size: 20px;
    font-weight: bold;
} */

.button{
    margin: 6px;
    text-align: center;
}

.button .change{
    margin-right: 20px;
    text-align: center;
}

.button .cancel{
    margin-left: 20px;
    text-align: center;
}

.item-text{
    width:1180px;
    max-height: 310px;
    margin: auto;
    margin-top: 6px;
}
.item-text .use{
    width: 1180px;
    height: 110px;
    max-width: 1180px;
    max-height: 110px;
    margin: auto;
    padding: 3px;
    border-radius: 10px;
    border: rgb(238, 236, 236) solid 2px;
    background: rgb(238, 236, 236);
}
.item-text .use span{
    text-align: center;
    font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic,
        "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
    color: #333333;
    font-size: 10px;
    font-weight: bold;
}
.item-text .material{
    width: 1180px;
    height: 70px;
    max-width: 1180px;
    max-height: 70px;
    margin: auto;
    margin-top: 3px;
    padding: 5px;
    border-radius: 10px;
    border: rgb(238, 236, 236) solid 2px;
    background: rgb(238, 236, 236);
}
.item-text .material span{
    text-align: center;
    font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic,
        "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
    color: #333333;
    font-size: 10px;
    font-weight: bold;
}

.item-text .distribution{
    width: 1180px;
    height: 130px;
    max-width: 1180px;
    max-height: 130px;
    margin: auto;
    margin-top: 2px;
    padding: 5px;
    border-radius: 10px;
    border: rgb(238, 236, 236) solid 2px;
    background: rgb(238, 236, 236);
}
.item-text .distribution span{
    text-align: center;
    font-family: "Yu Gothic Medium", "游ゴシック Medium", YuGothic,
        "游ゴシック体", "ヒラギノ角ゴ Pro W3", "メイリオ", sans-serif;
    color: #333333;
    font-size: 10px;
    font-weight: bold;
}
</style>